// import logo from './logo.svg';
// import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import './assets/scss/common.scss'

import CardFeatures from './components/CardFeatures/CardFeatures';
import Header from './components/Header';
import HeroBanner from './components/HeroBanner';
import SimpleSteps from './components/SimpleSteps/SimpleSteps';


function App() {
  return (
    <div className="App">
     <Header/>
     <HeroBanner/>
     <CardFeatures/>
     <SimpleSteps/>
    </div>
  );
}

export default App;
